module.exports = __webpack_public_path__ + "img/73369eb.jpg";